import ImageIcon from '@mui/icons-material/Image';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';

const ToggleSwitch = (props: any) => {
    const { toggled } = props;

    return (
        <button className={classNames(globalStyles.space_between_item, globalStyles.default_button_style)}>
            {toggled && <RemoveRedEyeIcon className={globalStyles.mr_1}></RemoveRedEyeIcon>}
            {!toggled && <ImageIcon className={globalStyles.mr_1}></ImageIcon>}
            {toggled && <label className={globalStyles.cursor_pointer}>3D</label>}
            {!toggled && <label className={globalStyles.cursor_pointer}>2D</label>}
        </button>
    );
};

export default ToggleSwitch;
